import { observer } from 'mobx-react';
import { Button } from '@roc/ui';
import { Layout } from '@roc/feature-app-core';
import { Box, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import { QuoteStep } from 'libs/feature-one-tool/src/quote/utils/constants';
import { CapitalProviderInfo } from '../common/capitalProviderInfo';
import { ClosingDetailsCard } from '../common/closingDetailsCard'

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '34px',
  },
  paper: {},

  stepperWrapper: {
    flex: 1,
    padding: theme.spacing(3.5, 3.5),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1, 1),
    },
  },
}));

export const FinalDetailsStep = observer(({ store }) => {
  const classes = useStyles();
  const formStore = store.finalDetailsStore.finalDetailsFormStore;

  return (
    <Layout maxWidth={'lg'}>
      <Box display={'flex'} alignItems={'center'} pb={2}>
        <Typography
          align="left"
          variant="h2"
          style={{
            color: '#5E5E5E',
            fontSize: '48px',
          }}
        >
          Final Details
        </Typography>
        <Box flex={1} />
        <CapitalProviderInfo capitalProvider={store.capitalProviderName} />
      </Box>
      <Paper className={classes.paper} elevation={0}>
        <Box display="flex">
          <Box className={classes.stepperWrapper}>
            <Grid container spacing={2}>
              <ClosingDetailsCard formStore={formStore} />
              <Grid item xs={12}>
                <Box pt={3}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={2}
                  >
                    <Grid item xs={6} md={3}>
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        onClick={() => store.goToStep(QuoteStep.SUMMARY)}
                        testId="previous"
                      >
                        Back
                      </Button>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Button
                        testId="continue"
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => store.submitLoan()}
                      >
                        SAVE LOAN
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Paper>
    </Layout>
  );
});
